<script>
import { signContractDrawn } from "../../api/user";
import Cropper from 'cropperjs';

export default {
  name: "ManualSignDialog",
  props: {
    show: { type: Boolean, default: false }
  },
  emits: ["close", "success"],
  data() {
    return {
      activeTab: 'draw',
      isDrawing: false,
      hasDrawing: false,
      rawImageSrc: null,
      croppedImage: null,
      cropper: null,
      cropConfirmed: false,
      isDragging: false,
      error: '',
      submitting: false,
    }
  },
  methods: {
    getPos(e, canvas) {
      const rect = canvas.getBoundingClientRect()
      const scaleX = canvas.width / rect.width
      const scaleY = canvas.height / rect.height
      if (e.touches) {
        return {
          x: (e.touches[0].clientX - rect.left) * scaleX,
          y: (e.touches[0].clientY - rect.top) * scaleY
        }
      }
      return {
        x: (e.clientX - rect.left) * scaleX,
        y: (e.clientY - rect.top) * scaleY
      }
    },
    startDraw(e) {
      e.preventDefault()
      const canvas = this.$refs.canvas
      const ctx = canvas.getContext('2d')
      const pos = this.getPos(e, canvas)
      this.isDrawing = true
      ctx.beginPath()
      ctx.moveTo(pos.x, pos.y)
    },
    draw(e) {
      if (!this.isDrawing) return
      e.preventDefault()
      const canvas = this.$refs.canvas
      const ctx = canvas.getContext('2d')
      const pos = this.getPos(e, canvas)
      ctx.lineWidth = 2
      ctx.lineCap = 'round'
      ctx.strokeStyle = '#0C293A'
      ctx.lineTo(pos.x, pos.y)
      ctx.stroke()
      this.hasDrawing = true
    },
    stopDraw() { this.isDrawing = false },
    /**
     * Зурсан гарын үсэг canvas-ийн багахан хэсгийг эзэлдэг тул эргэн тойрны
     * ил тод хэсгийг нь хайчилж, зөвхөн бэхтэй хэсгийг үлдээнэ.
     */
    trimCanvas(source, padding = 8) {
      const { width, height } = source
      const { data } = source.getContext('2d').getImageData(0, 0, width, height)

      let top = height, left = width, right = -1, bottom = -1
      for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
          // Alpha суваг - зөвхөн зурсан цэгүүд 0-ээс их утгатай байна
          if (data[(y * width + x) * 4 + 3] === 0) continue
          if (x < left) left = x
          if (x > right) right = x
          if (y < top) top = y
          if (y > bottom) bottom = y
        }
      }

      // Юу ч зураагүй бол хэвээр нь буцаана
      if (right < 0) return source

      left = Math.max(0, left - padding)
      top = Math.max(0, top - padding)
      right = Math.min(width - 1, right + padding)
      bottom = Math.min(height - 1, bottom + padding)

      const trimmed = document.createElement('canvas')
      trimmed.width = right - left + 1
      trimmed.height = bottom - top + 1
      trimmed.getContext('2d').drawImage(
        source,
        left, top, trimmed.width, trimmed.height,
        0, 0, trimmed.width, trimmed.height,
      )
      return trimmed
    },
    clearCanvas() {
      const canvas = this.$refs.canvas
      if (!canvas) { this.hasDrawing = false; return }
      canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height)
      this.hasDrawing = false
    },

    onFileChange(e) {
      const file = e.target.files[0]
      this.handleFile(file)
      e.target.value = ''
    },
    onDrop(e) {
      this.isDragging = false
      this.handleFile(e.dataTransfer.files[0])
    },
    handleFile(file) {
      if (!file) return
      if (!file.type.startsWith('image/')) {
        this.error = 'Зөвхөн зураг оруулна уу'
        return
      }
      this.error = ''
      this.cropConfirmed = false
      this.croppedImage = null
      const reader = new FileReader()
      reader.onload = (e) => {
        this.rawImageSrc = e.target.result
        this.$nextTick(() => this.initCropper())
      }
      reader.readAsDataURL(file)
    },

    initCropper() {
      this.destroyCropper()
      const img = this.$refs.cropperImg
      if (!img) return
      this.cropper = new Cropper(img, {
        template: `
          <cropper-canvas background>
            <cropper-image rotatable scalable translatable></cropper-image>
            <cropper-shade hidden></cropper-shade>
            <cropper-handle action="select" plain></cropper-handle>
            <cropper-selection initial-coverage="0.9" movable resizable zoomable>
              <cropper-grid role="grid" bordered covered></cropper-grid>
              <cropper-crosshair centered></cropper-crosshair>
              <cropper-handle action="move" theme-color="rgba(12,41,58,0.3)"></cropper-handle>
              <cropper-handle action="n-resize"></cropper-handle>
              <cropper-handle action="e-resize"></cropper-handle>
              <cropper-handle action="s-resize"></cropper-handle>
              <cropper-handle action="w-resize"></cropper-handle>
              <cropper-handle action="ne-resize"></cropper-handle>
              <cropper-handle action="nw-resize"></cropper-handle>
              <cropper-handle action="se-resize"></cropper-handle>
              <cropper-handle action="sw-resize"></cropper-handle>
            </cropper-selection>
          </cropper-canvas>
        `
      })

      this.$nextTick(() => {
        const stage = this.$refs.cropperStage
        const cropperCanvas = stage && stage.querySelector('cropper-canvas')
        if (cropperCanvas) {
          cropperCanvas.style.height = '320px'
          cropperCanvas.style.width = '100%'
        }
      })
    },
    destroyCropper() {
      if (this.cropper) {
        this.cropper.destroy()
        this.cropper = null
      }
    },
    async confirmCrop() {
      if (!this.cropper) return
      try {
        const selection = this.cropper.getCropperSelection()
        if (!selection) return
        const canvas = await selection.$toCanvas({ width: 1200 })
        this.croppedImage = canvas.toDataURL('image/png')
        this.cropConfirmed = true
        this.destroyCropper()
      } catch (err) {
        this.error = 'Crop хийхэд алдаа гарлаа'
      }
    },
    resetCrop() {
      this.cropConfirmed = false
      this.croppedImage = null
      if (this.rawImageSrc) {
        this.$nextTick(() => this.initCropper())
      }
    },
    removeImage() {
      this.destroyCropper()
      this.rawImageSrc = null
      this.croppedImage = null
      this.cropConfirmed = false
    },

    async submit() {
      try {
        this.submitting = true
        this.error = ''
        const signatureType = this.activeTab === 'draw' ? 'drawn' : 'uploaded'
        let file
        if (this.activeTab === 'draw') {
          const trimmed = this.trimCanvas(this.$refs.canvas)
          const blob = await new Promise(resolve => trimmed.toBlob(resolve, 'image/png'))
          file = new File([blob], 'signature.png', { type: 'image/png' })
        } else {
          const res = await fetch(this.croppedImage)
          const blob = await res.blob()
          file = new File([blob], 'signature.png', { type: 'image/png' })
        }
        await signContractDrawn('main', file, signatureType)
        this.$emit('success')
      } catch (e) {
        this.error = e?.response?.data?.errors?.type?.[0] ?? 'Алдаа гарлаа. Дахин оролдоно уу.'
      } finally {
        this.submitting = false
      }
    },

    handleClose() {
      this.clearCanvas()
      this.removeImage()
      this.error = ''
      this.activeTab = 'draw'
      this.$emit('close')
    },
    switchTab(tab) {
      if (tab === 'draw') {
        this.removeImage()
      } else {
        this.clearCanvas()
      }
      this.activeTab = tab
      this.error = ''
    }
  },

  watch: {
    show(val) {
      if (!val) {
        this.clearCanvas()
        this.removeImage()
        this.error = ''
        this.activeTab = 'draw'
      }
    }
  },

  computed: {
    canSubmit() {
      if (this.activeTab === 'draw') return this.hasDrawing
      return this.cropConfirmed && !!this.croppedImage
    }
  },

  beforeUnmount() {
    this.destroyCropper()
  }
}
</script>

<template>
  <ic-dialog :show="show">
    <div class="manual-sign-dialog">
      <a @click.stop="handleClose" class="icon-btn close-btn">
        <i class="sr sr-close"></i>
      </a>

      <h3 class="dialog-title">{{ $t('sign_dialog.write_signature') }}</h3>

      <!-- Tabs -->
      <div class="tabs">
        <button
          class="tab-btn"
          :class="{ active: activeTab === 'draw' }"
          @click="switchTab('draw')"
        >
          <i class="sr sr-edit"></i>
          {{ $t('sign_dialog.handwrite') }}
        </button>
        <button
          class="tab-btn"
          :class="{ active: activeTab === 'upload' }"
          @click="switchTab('upload')"
        >
          <i class="sr sr-upload"></i>
          {{ $t('sign_dialog.import_image') }}
        </button>
      </div>

      <!-- Draw tab -->
      <div v-if="activeTab === 'draw'" class="tab-content">
        <p class="hint">{{ $t('sign_dialog.handwrite_hint') }}</p>
        <div class="canvas-wrapper">
          <canvas
            ref="canvas"
            width="620"
            height="320"
            class="sign-canvas"
            @mousedown="startDraw"
            @mousemove="draw"
            @mouseup="stopDraw"
            @mouseleave="stopDraw"
            @touchstart="startDraw"
            @touchmove="draw"
            @touchend="stopDraw"
          ></canvas>
          <div class="canvas-baseline"></div>
          <div v-if="!hasDrawing" class="canvas-placeholder">
            {{ $t('sign_dialog.handwrite_area') }}
          </div>
          <div v-if="hasDrawing" class="canvas-overlay">
            <ic-button size="tn" class="clear-btn" @click="clearCanvas">
              {{ $t('sign_dialog.clear') }}
            </ic-button>
          </div>
        </div>
      </div>

      <!-- Upload tab -->
      <div v-else class="tab-content">

        <!-- 1. Dropzone -->
        <div
          v-if="!rawImageSrc"
          class="dropzone"
          :class="{ dragging: isDragging }"
          @dragover.prevent="isDragging = true"
          @dragleave="isDragging = false"
          @drop.prevent="onDrop"
          @click="$refs.fileInput.click()"
        >
          <i class="sr sr-upload upload-icon"></i>
          <p class="upload-hint">{{ $t('sign_dialog.import_hint') }}</p>
          <span class="upload-formats">PNG, JPG, JPEG</span>
        </div>

        <!-- 2. Cropper -->
        <div v-else-if="!cropConfirmed" class="cropper-wrapper">
          <div ref="cropperStage" class="cropper-stage">
            <img
              ref="cropperImg"
              :src="rawImageSrc"
              class="cropper-source-img"
              alt="crop source"
            />
          </div>
          <div class="crop-toolbar">
            <ic-button size="tn" class="btn-discard" @click="removeImage">
              {{ $t('sign_dialog.clear') }}
            </ic-button>
            <ic-button size="tn" class="btn-confirm-crop" @click="confirmCrop">
              {{ $t('sign_dialog.crop_confirm') || 'Crop хийх' }}
            </ic-button>
          </div>
        </div>

        <!-- 3. Preview -->
        <div v-else class="image-preview-wrapper">
          <img :src="croppedImage" class="image-preview" alt="Гарын үсэг" />
          <div class="image-overlay">
            <ic-button size="tn" class="btn-reupload" @click="resetCrop">
              {{ $t('sign_dialog.crop_redo') || 'Дахин crop' }}
            </ic-button>
          </div>
        </div>

        <input
          ref="fileInput"
          type="file"
          accept="image/*"
          style="display: none"
          @change="onFileChange"
        />
      </div>
      <div v-if="error" class="error-msg">{{ error }}</div>
      <div class="dialog-actions">
        <ic-button
          size="tn"
          :disabled="!canSubmit"
          :loading="submitting"
          @click="submit"
          class="submit-btn"
        >
          {{ $t('kyc.confirm.verify') }}
        </ic-button>
      </div>
    </div>
  </ic-dialog>
</template>

<style scoped lang="scss">

.submit-btn       { background: #0C293A !important; }
.clear-btn        { background-color: #F8E5E5 !important; color: #DA2128 !important; }
.btn-discard      { background-color: #F8E5E5 !important; color: #DA2128 !important; }
.btn-reupload     { background: #E6EEF1 !important; color: #0C293A !important; }
.btn-confirm-crop { background: #0C293A !important; color: #fff !important; }

.manual-sign-dialog {
  position: relative;
  padding: 24px;
  width: 680px;
  max-width: 95vw;
  background-color: #fafafa;
  border-radius: 12px;
}

.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
}

.dialog-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary-color);
  margin: 0 0 20px;
}

.tabs {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 20px;
}

.tab-btn {
  background: none;
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  color: #888;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: color 0.2s, border-color 0.2s;
  &.active { border-bottom-color: #e53935; color: #0C293A; }
  &:hover:not(.active) { color: #555; }
}

.tab-content { min-height: 320px; }

.hint {
  font-size: 13px;
  color: #888;
  margin-bottom: 12px;
}

.canvas-wrapper {
  position: relative;
  border: 1.5px dashed #ccc;
  border-radius: 8px;
  overflow: hidden;
  background: #fafafa;
  cursor: crosshair;
  &:hover { border-color: #0C293A; }
}
.sign-canvas {
  display: block;
  width: 100%;
  height: 320px;
  touch-action: none;
}
.canvas-baseline {
  position: absolute;
  top: calc(50% + 24px);
  left: 24px; right: 24px;
  height: 1px;
  background-color: #bbb;
  pointer-events: none;
}
.canvas-placeholder {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  color: #bbb;
  pointer-events: none;
  white-space: nowrap;
}
.canvas-overlay {
  position: absolute;
  bottom: 10px; right: 10px;
}

.dropzone {
  border: 1.5px dashed #ccc;
  border-radius: 8px;
  height: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  background: #fafafa;
  transition: border-color 0.2s, background 0.2s;
  &:hover, &.dragging {
    border-color: #0C293A;
    background: #f0f4f7;
  }
}
.upload-icon { font-size: 32px; color: #bbb; display: block; margin-bottom: 12px; }
.upload-hint { font-size: 14px; color: #555; margin: 0 0 6px; }
.upload-formats { font-size: 12px; color: #aaa; }

// Cropper
.cropper-wrapper {
  border: 1.5px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.cropper-stage {
  width: 100%;
  height: 320px;
  overflow: hidden;
  background: #2a2a2a;
  position: relative;

  :deep(cropper-canvas) {
    display: block;
    width: 100% !important;
    height: 320px !important;
  }

  :deep(cropper-image) {
    object-fit: contain;
  }

  :deep(cropper-selection) {
    outline: 2px solid rgba(12, 41, 58, 0.8);
  }

  :deep(cropper-handle[action="move"]) {
    background: rgba(12, 41, 58, 0.25);
  }
}

.cropper-source-img {
  display: none;
}

.crop-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: #f4f4f4;
  border-top: 1px solid #e0e0e0;
}

// Preview
.image-preview-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 320px;
  border: 1.5px dashed #ccc;
  border-radius: 8px;
  overflow: hidden;
  background: #fafafa;
}
.image-preview {
  max-width: 100%;
  max-height: 320px;
  object-fit: contain;
  display: block;
}
.image-overlay {
  position: absolute;
  bottom: 10px; right: 10px;
}

// Error & actions
.error-msg {
  color: #e53935;
  font-size: 13px;
  margin-top: 12px;
}
.dialog-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}
</style>
